import { render, staticRenderFns } from "./pedidos_pendientes.vue?vue&type=template&id=3d2ca944&"
import script from "./pedidos_pendientes.vue?vue&type=script&lang=js&"
export * from "./pedidos_pendientes.vue?vue&type=script&lang=js&"
import style0 from "./pedidos_pendientes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports